const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* ============================================================
   NAKAMA - Navegacion del carrusel de resenas
   Anadido: 14/07/2026

   Inyecta una barra debajo de las resenas con:  <  [====----]  >
   Las flechas desplazan una tarjeta cada vez y se desactivan al
   llegar a los extremos. La barra muestra la posicion.

   Se hace desde JS porque el CSS/HTML original de las resenas vive
   dentro de iurop-layout.css (294 KB), que no se puede editar con
   seguridad. Esto NO toca la seccion de resenas.

   Para desactivarlo: borrar este bloque.
   ============================================================ */
(function () {
  'use strict';

  function buildNav(track) {
    if (!track || track.dataset.nkNav === 'true') return;
    track.dataset.nkNav = 'true';

    var section = track.closest('.reviews-section') || track.parentElement;
    if (!section) return;

    var bar = document.createElement('div');
    bar.className = 'nk-rev-nav';

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'nk-rev-nav__arrow nk-rev-nav__arrow--prev';
    prev.setAttribute('aria-label', 'Anterior');
    prev.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>';

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'nk-rev-nav__arrow nk-rev-nav__arrow--next';
    next.setAttribute('aria-label', 'Siguiente');
    next.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>';

    var rail = document.createElement('div');
    rail.className = 'nk-rev-nav__rail';
    var fill = document.createElement('div');
    fill.className = 'nk-rev-nav__fill';
    rail.appendChild(fill);

    bar.appendChild(prev);
    bar.appendChild(rail);
    bar.appendChild(next);
    section.appendChild(bar);

    function step() {
      var card = track.querySelector('.reviews-section__card');
      if (!card) return track.clientWidth * 0.8;
      var style = window.getComputedStyle(track);
      var gap = parseInt(style.columnGap || style.gap, 10) || 20;
      return card.getBoundingClientRect().width + gap;
    }

    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function update() {
      var max = maxScroll();
      var pos = track.scrollLeft;

      prev.disabled = pos <= 2;
      next.disabled = pos >= max - 2;

      // Si todo cabe en pantalla, no hace falta la barra
      bar.style.display = (max <= 2) ? 'none' : 'flex';

      var ratio = max > 0 ? (pos / max) : 0;
      var visible = track.clientWidth / track.scrollWidth;
      var fillWidth = Math.max(12, visible * 100);
      fill.style.width = fillWidth + '%';
      fill.style.left = (ratio * (100 - fillWidth)) + '%';
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    update();
    setTimeout(update, 400);
  }

  function init() {
    var tracks = document.querySelectorAll('.reviews-section__cards');
    Array.prototype.forEach.call(tracks, buildNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
